import React, { PropsWithChildren, useState, JSX } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp, IconDefinition } from '@fortawesome/free-solid-svg-icons';

import { Button, Collapse } from 'reactstrap';
import { FilterProperties } from '../../../SubModules/ServiceList/externals';

interface Props {
  label: string;
  collapsable?: boolean;
  resetLabel?: string;
  icon?: IconDefinition;
  filterProps?: FilterProperties;
  onDiscard?: () => void;
  isResetButtonActive?: boolean;
}

const FilterContent = (props: PropsWithChildren<Props>): JSX.Element => {
  const { collapsable, children, label, onDiscard, resetLabel, isResetButtonActive } = props;

  const [isOpen, setIsOpen] = useState(true);

  const handleResetClick = () => {
    if (onDiscard) onDiscard();
  };

  return (
    <>
      <div className="iso__baseLayoutFilter__headlineContent mb-1">
        {collapsable && (
          <button
            type="button"
            className="iso__baseLayoutFilter__filterItemButton"
            onClick={(): void => setIsOpen(!isOpen)}
          >
            <div className="iso__baseLayoutFilter__buttonContent">
              <span className="iso__baseLayoutFilter__headline">{label}</span>
              <span className="iso__baseLayoutFilter__caret">
                {!isOpen && <FontAwesomeIcon icon={faAngleDown} className="fas fa-lg" />}
                {isOpen && <FontAwesomeIcon icon={faAngleUp} className="fas fa-lg" />}
              </span>
            </div>
          </button>
        )}
        {!collapsable && <div className="iso__baseLayoutFilter__headline">{label}</div>}
      </div>
      <Collapse isOpen={isOpen}>
        <div className="iso__filter__discardContainer">
          {isResetButtonActive && (
            <Button
              color="link"
              className="border-0 p-0 font-weight-normal iso__filter__resetButton"
              onClick={handleResetClick}
            >
              {resetLabel}
            </Button>
          )}
        </div>
        {children}
      </Collapse>
    </>
  );
};

const BaseLayoutFilter = (props: PropsWithChildren<Props>): JSX.Element => {
  const { icon, children, collapsable, label, resetLabel, isResetButtonActive } = props;

  return (
    <div className={`iso__baseLayoutFilter pt-2${!!icon ? ' iso__baseLayoutFilter__icon' : ''}`}>
      {!!icon ? (
        <>
          <FontAwesomeIcon icon={icon} />
          <div className="iso__baseLayoutFilter__inner">
            <FilterContent
              children={children}
              collapsable={collapsable}
              label={label}
              filterProps={props.filterProps}
              onDiscard={props.onDiscard}
              resetLabel={resetLabel}
              isResetButtonActive={isResetButtonActive}
            />
          </div>
        </>
      ) : (
        <FilterContent
          children={children}
          collapsable={collapsable}
          label={label}
          filterProps={props.filterProps}
          onDiscard={props.onDiscard}
          resetLabel={resetLabel}
          isResetButtonActive={isResetButtonActive}
        />
      )}
    </div>
  );
};

export default BaseLayoutFilter;
